import React, { Fragment, useState, useRef } from 'react';
import { translate } from '../Services/translation';
import useOnclickOutside from 'react-cool-onclickoutside';

const Languages = ({ languages, country }) => {
  const [showLanguages, setShowLanguages] = useState(false);
  const currentLanguage =
    languages.find((l) => l.selected) ||
    languages.find((l) => l.isPreferredLanguage) ||
    languages[0];

  // Order by selected or preferred language
  languages = [
    currentLanguage,
    ...languages.filter((x) => x !== currentLanguage && !x.isFallbackChannel),
  ];
  const langSelectRef = useOnclickOutside(() => {
    setShowLanguages(false);
  });
  if (languages?.length == 1) {
    return (
      <Fragment>
        <h6 className="mobile-header">{country}</h6>
        <ul className="languages__menu-links">
          {languages.map((lang, index) => (
            <li
              className="language__item"
              key={`language-${lang.languageName}-${index}`}
            >
              <a
                href={lang.url}
                className={`language-selector__window__link ${
                  lang.selected
                    ? 'language-selector__window__link--selected'
                    : ''
                }`}
              >
                {lang.languageName}
              </a>
            </li>
          ))}
        </ul>
      </Fragment>
    );
  } else if (languages?.length > 1) {
    return (
      <Fragment>
        <h6 className="mobile-header">{country}</h6>
        <div
          className={`language-selector__multiple-languages language-selector__window__link ${
            currentLanguage.selected
              ? 'language-selector__window__link--selected'
              : ''
          }`}
          onClick={() => {
            setTimeout(() => {
              setShowLanguages(!showLanguages);
            }, 10);
          }}
        >
          {currentLanguage.languageName}
        </div>

        <ul
          className={`languages__menu-links${showLanguages ? '--show' : ''}`}
          ref={langSelectRef}
        >
          {languages.map((lang, indx) => (
            <li
              className="language__item"
              key={`language2-${lang.languageName}-${indx}`}
            >
              <a
                href={lang.url}
                className={`language-selector__window__link ${
                  lang.selected
                    ? 'language-selector__window__link--selected'
                    : ''
                }`}
              >
                {lang.languageName}
              </a>
            </li>
          ))}
        </ul>
      </Fragment>
    );
  }
  return null;
};

const LanguageSelectorItem = ({
  country,
  languages,
  changeMobileWindowIndex,
  changeMobileCountry,
  mobileWindowIndex,
}) => {
  const menuRef = useRef(null);

  const toggleMenu = (e) => {
    e.preventDefault();
    const classList = menuRef?.current?.classList;
    changeMobileWindowIndex(mobileWindowIndex);
  };

  const selected = languages.find((l) => l.selected);
  return (
    <Fragment>
      <div
        className="language-selector__group"
        onClick={(e) => {
          toggleMenu(e);
          changeMobileCountry(country);
        }}
      >
        <h6>{country}</h6>
        {selected && (
          <p className="language-selector__group--selected">
            {selected.languageName}
            <span className="language-selector__group__selected-icon" />
          </p>
        )}
      </div>

      <i className="language-selector__icon language-selector--caret-right"></i>
      <div
        ref={menuRef}
        className={`language-selector__window__languages ${
          mobileWindowIndex > 1
            ? 'language-selector__window__languages--show'
            : ''
        }`}
      >
        <div className="language-selector__country-header">
          <h3>{country}</h3>
        </div>

        <div className="language-selector__country-subheader">
          <p>{translate('languageselector.chooselanguage')}</p>
        </div>

        <Languages languages={languages} country={country} />
      </div>
    </Fragment>
  );
};

export default LanguageSelectorItem;
